import {ReportType} from "@/dto/report/ReportType";
import Workspaces from "@/state/Workspaces";

export default class CreateReportPayload {
    public reportType: ReportType | string | null = null

    public requesterId: number | null = Workspaces.getCurrent.id;
}